import React, { useContext, useEffect, useState } from 'react';
import { Button, Col, Row } from 'antd';
import { FaCircleInfo } from "react-icons/fa6";
import OrderLIne from '../components/OrderLIne';
import CustomButton from '../components/CustomButton';
import CalculatorButton from '../components/CalculatorButton';
import { GiPayMoney } from "react-icons/gi";
import { FaNoteSticky } from "react-icons/fa6";
import { HiReceiptRefund } from "react-icons/hi2";
import { MdDiscount } from "react-icons/md";
import { MdOutlineStickyNote2 } from "react-icons/md";
import { FaMoneyBillWaveAlt, FaUser } from "react-icons/fa";
import { GiShoppingCart } from "react-icons/gi";
import { CiBarcode } from "react-icons/ci";
import { MdOutlineStarRate } from "react-icons/md";
import { MdOutlineLink } from "react-icons/md";
import { TbTruckDelivery } from "react-icons/tb";
import EventEmitter from '../../utils/eventEmitter';
import DeliveryRegionModal from '../modals/DeliveryRegionModal';
import { Outlet, useLocation, useNavigate, useOutletContext } from 'react-router-dom';
import GoBack from '../../globalComponents/GoBack';
import PaymentModal from '../modals/PaymentModal';
import { BASE_URL } from '../utils/axios';
import { MdPrint } from "react-icons/md";
import PosSessionContext from '../utils/PosSessionContext';
import { errorModal, info, successModal, warning } from '../modals/ModalMessages';
import proformaInvoice from '../utils/proformaInvoice';
import formatAmount from '../../utils/formatAmount';
import useCalculator from '../utils/useCalculator';

// import logo from '../utils/logo.txt';



const SellPage = () => {
  // const posOrder = useLoaderData();
  const location = useLocation();
  const navigate = useNavigate();
  const { state, dispatch, order, cashier, tax, user, getOrder } = useContext(PosSessionContext);
  const { success, error } = useOutletContext();
  const calculator = useCalculator(getOrder, state, dispatch, tax);


  const handleAddToCart = async (product) => {
    let carts_ = [...order.orderlines];
    let found = carts_.findIndex(cart => cart.id === product.id);
    if (found === -1) {
      let obj = {...product};
      obj.select = true;
      obj.quantity = 1;
      obj.pro_quantity = product.available_quantity;
      obj.subtotal = obj.quantity * (obj.sales_price*1);
      delete obj.available_quantity;
      if (product.tax_id) {
        let subtotal = obj.quantity * obj.sales_price;
        switch (product.tax_computation) {
          case 'percent_of_price':
            obj['tax'] = (parseFloat(product.tax_amount*1 / 100) * subtotal).toFixed(2) * 1;
            // setTax(prev => prev + taxEntryObj['amount']);
            break;
          case 'percent_of_price_included':
            obj['tax'] = (parseFloat(subtotal / 1 - (product.tax_amount*1 / 100))).toFixed(2) * 1;
            // setTax(prev => prev + taxEntryObj['amount']);
            break;
          case 'fixed':
            obj['tax'] = (parseFloat(subtotal + product.tax_amount*1 / 100 )).toFixed(2) * 1;
            // setTax(prev => prev + taxEntryObj['amount']);
            break;
        };
        obj.tax_id = product.tax_id;
      }else {
        obj.tax_amount = 0;
        // obj.pro_quantity = 0;
        obj.tax = 0;
      }
      carts_.forEach((_, id) => {
        if (carts_.length !== id) {
          carts_[id].select = false;
        };
      })
      carts_.push(obj);
      // const order_ = await updateSessionOrder({event: 'ADD_CART', product: obj});
      // console.log(carts_);
      dispatch({event: 'ADD_CART', item: carts_});
      // setOrder(getOrder(orders));
      // setCarts(carts_);
    }else {
      carts_[found].quantity = carts_[found].quantity + 1;
      dispatch({event: 'UPDATE_QUANTITY', items: carts_});
    }
  }



  const handleClick = async (item) => {
    try {
      let carts_ = [...order.orderlines];
      if (!item.select) {
        let foundSelected = carts_.findIndex(cart => cart.select === true);
        carts_[foundSelected].select = false;
        let found = carts_.findIndex(cart => cart.id === item.id);
        carts_[found].select = true;
        dispatch({event: 'SELECT_ORDER_LINE', items: carts_});
        // const order_ = await updateSessionOrder({event: 'SELECT_ORDER', cart: carts_});
        // setOrder(order_);
      };
    }catch (err) {
      throw err;
    }
  }


  const openDeliveryRegionModal = () => {
    EventEmitter.dispatch('opendeliveryregion', true);
  };

  const openPayment = () => {
    let data = {...order};
    let orders = [...state.orders];
    if (!data.is_ordered) return warning(
      'VERIFY ORDER!',
      <div>
        <p>Cart cannot be processed</p>
        <p>Please, mark the cart as order</p>
      </div>
    );
    if (state.session_id && data.customer_id) {
      if (data.orderlines.length > 0) {
        let index = orders.findIndex(order => order.createdAt === data.createdAt);
        let out_of_stock_producs = data.orderlines.filter(product => product.pro_quantity * 1 <= 0 || product.quantity > product.pro_quantity);
        if (out_of_stock_producs.length > 0) {
          // orders[index]['demand_sold'] = true;
          orders[index]['picking_state'] = order.is_refund === true ? 'delivered' : 'pick_later';
          dispatch({event: 'PICKING_STATE', orders: orders});
          if (order.is_refund === false) {
            warning(
              'OUT OF STOCK PRODUCT(S)!',
              <div>
                <p>You have out-of-stock product(s)</p>
                <p>If you want to sell check demand sold or leave to create demand.</p>
                <p>Thank you.</p>
              </div>
            );
          }
          navigate('/pos/session/order/payment/'+state.session_id);
        }else {
          orders[index]['picking_state'] = 'delivered';
          dispatch({event: 'PICKING_STATE', orders: orders});
          // alert('Proceed to make payment');
          navigate('/pos/session/order/payment/'+state.session_id);
        }
      }else {
        errorModal('EMPTY CART!', <p>Cart is empty. Add product to cart then proceed with the payment</p>)
      }
    }else {
      errorModal(
        'OOPS! AN ERROR HAS OCCURED!', 
        <div>
          <p>Please, check whether delivery region and customer have been choosen.</p>
          <p>If error still persist, contact system engineer.</p>
          <p>Thank you.</p>
        </div>
      );
    }
  }

  useEffect(() => {

    EventEmitter.subscribe('posorderdeliveryregion', async data => {
      // const info = await updateSessionOrder({event: 'ADD_DELIVERY_REGION', delivery_region: data});      
      // setOrder(info);
      dispatch({event: 'ADD_DELIVERY_REGION', delivery_region: data});
    });

    EventEmitter.subscribe('posordercontactselected', async data => {
      let order_ = {...order};
      order_.name = data.cus_name;
      order_.id = data.id;
      order.cus_phone = data.cus_phone;
      dispatch({event: 'ADD_CUSTOMER', customer: order_});
      // const info = await updateSessionOrder({event: 'ADD_CUSTOMER', customer_id: data.id, cus_name: data.cus_name});      
      // setOrder(info);
    });

    EventEmitter.subscribe('posAddToCart', data => {
      if (order.status !== 'paid') handleAddToCart(data);
    });

    return () => {
      EventEmitter.unsubscribe('posordercontactselected');
      EventEmitter.unsubscribe('posAddToCart');
      EventEmitter.unsubscribe('posorderdeliveryregion');
    }
  },[])


  const handleOrder = async () => {
    try {
      if (order.cus_name) {
        // const info = await updateSessionOrder({event: 'MARK_ORDER'});
        // setOrder(info);
        order.is_ordered = !order.is_ordered;
        if (order.is_ordered) {
          order.status = 'ongoing';
          order.createdAt = new Date();
        }else {
          order.status = 'new';
          order.createdAt = ''
        };
        order.cashier_id = cashier.id;
        dispatch({event: 'MARK_ORDER', item: order});
      }else {
        errorModal('UNKNOWN CUSTOMER', <p>Please choose customer to proceed</p>)
      }
    }catch (err) {
      console.log(err);
    }
  }

  // useEffect(() => {
  //   const es = new EventSource("http://192.168.43.42:7700/pos-session/stream", {withCredentials: true});
  //   es.addEventListener('open', (event) => {
  //     console.log("Open SSE connection.");
  //   });

  //   es.addEventListener("message", (event) => { 
  //     if (event) {
  //       const data = JSON.parse(event.data);
  //       if (data.message) {
  //         setOrder(data.message);
  //       } 
  //     }
  //   });
    
  //   es.addEventListener("error", (event) => {
  //     if (event.type === "error") {
  //       console.error("Connection error:", event.message);
  //     } else if (event.type === "exception") {
  //       console.error("Error:", event.message, event.error);
  //     }
  //   });
    
  //   es.addEventListener("close", (event) => {
  //     console.log("Close SSE connection.");
  //   });
  //   return () => {
  //     es.close();
  //   }
  // },[])

  // if (localStorage.getItem('pos_session_id') === null) navigate('/sales/')


  const handleKeyboardInput = (event) => {
    const key = event.key;
    
    // Check if the key is a number (0-9) or decimal point (.)
    if (event.ctrlKey || event.key === 'Control' || event.key === 'Fn') {
      // event.preventDefault(); // Prevent default behavior of these keys
      console.log("Ctrl or Fn key pressed, action prevented.");
    }else {
      if (/[0-9]/.test(key)) {
        calculator.addQuantity(key);
        console.log(key)
      }
        // Check for Enter key to trigger calculation
      else if (key === "Enter") {
        // handleOk();
        console.log('enter pressed');
      }
      // Check for backspace key to clear the last character (delete)
      else if (key === "Backspace") {
        calculator.deleteQuantity();
        console.log('backspace pressed');
      }
      // Check for Escape key to clear the display
      else if (key === "Escape") {
        // resetPasscode();
          console.log('esc pressed');
      }
    }
  };

  // useEffect (() => {
  //   let productSearch = window.document.getElementById('product-search');
  //   // let customerSearch = window.document.getElementById('customer-search');

      
  //   // document.addEventListener('keydown', handleKeyboardInput);


  //   // productSearch.addEventListener('focus', () => {
  //   //   // Disable global listener (if input2 is focused)
  //   //   document.removeEventListener('keydown', handleKeyboardInput);
  
  //   //   // Add focused key listener to input2
  //   //   productSearch.addEventListener('keydown', () => {});
  //   // });

  //   // productSearch.addEventListener('blur', () => {
  //   //   // Remove focused listener from input2 (when it loses focus)
  //   //   productSearch.removeEventListener('keydown', () => {});
  
  //   //   // Re-enable the global listener
  //   //   document.addEventListener('keydown', handleKeyboardInput);
  //   // });


  //   // customerSearch?.addEventListener('focus', () => {
  //   //   // Disable global listener (if input2 is focused)
  //   //   document.removeEventListener('keydown', handleKeyboardInput);
  
  //   //   // Add focused key listener to input2
  //   //   customerSearch?.addEventListener('keydown', () => {});
  //   // });

  //   // customerSearch?.addEventListener('blur', () => {
  //   //   // Remove focused listener from input2 (when it loses focus)
  //   //   customerSearch?.removeEventListener('keydown', () => {});
  
  //   //   // Re-enable the global listener
  //   //   document.addEventListener('keydown', handleKeyboardInput);
  //   // });

  // },[])
 
  



  function printDynamicContent() {
    // Generate the dynamic HTML
    const dynamicHTML = proformaInvoice(order.orderlines, formatAmount, order.is_refund);

    // Open a new window or tab
    const printWindow = window.open('', '', 'height=500,width=800');

    // Write the dynamically generated HTML to the new window
    printWindow.document.write(dynamicHTML);
    
    // Close the document stream to ensure everything is loaded
    printWindow.document.close();
    
    // Trigger the print dialog
    printWindow.print();

    // Optionally, you can close the print window after printing
    printWindow.close();
  }

  const handleRefund = () => {
    let refundOrder = {...order};
    refundOrder.is_refund = !refundOrder.is_refund; 
    // let refundOrderLines = refundOrder.orderlines;
    // refundOrderLines.forEach((_, idx) => {
    //   refundOrderLines[idx].quantity = String((refundOrderLines[idx].quantity * 1) * -1);
    //   refundOrderLines[idx].subtotal = String((refundOrderLines[idx].subtotal * 1) * -1);
    //   refundOrderLines[idx].tax = String((refundOrderLines[idx].tax * 1) * -1);
    // });
    // refundOrder.orderlines = refundOrderLines;
    dispatch({event: 'MARK_ORDER', item: refundOrder});
  }

  const gotoPrint = () => {
    navigate('/pos/session/order/reprint'); 
  }


  
  return (
    <div className='container mx-auto' style={{ maxWidth: '1500px'}}>
      <div id='pos-ui'>
        <Row className='h-full'>
          <Col md={{span: 8}} >
            <div className='bg-white border h-full flex flex-col justify-between'>
              <div className='left-pane-one'>
                <div className='orderlines-container'>
                  {order.orderlines?.map(cart => <OrderLIne onClick={handleClick} key={cart.id} cart={cart} is_refund={order.is_refund}/>)}
                  {order.orderlines.length > 0 && 
                    <div className='border-t border-b py-2'>
                      <div className='flex justify-end me-3 font-semibold text-gray-700 text-xl'>
                        <p className='font-bold me-3'>Total: </p>
                        <p>GHc {formatAmount(order.orderlines.reduce((prev, current) => (((current.sales_price * (order.is_refund ? current.quantity * -1 : current.quantity*1))+ prev * 1)), 0))}</p>
                      </div>
                      <div className='flex justify-end me-3 font-normal text-gray-700 text-lg'>
                        <p className='font-normal me-3'>Taxes: </p>
                        <p>GHc {formatAmount(order.orderlines.reduce((prev, current) => ((order.is_refund ? current.tax * -1 : current.tax* 1) + prev), 0))}</p>
                      </div>
                    </div>
                  }
                </div>
              </div>
              <div className='left-pane-two' >
                
                <div className='grid grid-cols-3 h-1/2'>
                  {order.status !== 'paid' &&
                    <>
                    <CustomButton text={'Delivery Region'} icon={<TbTruckDelivery />} onClick={openDeliveryRegionModal}/>
                    <CustomButton text={'Refund'} icon={<HiReceiptRefund />} selected={order.is_refund} onClick={handleRefund}/>
                    <CustomButton text={'Invoice Preview'} icon={<FaCircleInfo />} onClick={printDynamicContent}/>
                    <CustomButton text={'Internal Note'} icon={<MdOutlineStickyNote2 />}/>
                    <CustomButton text={'Invoice'} icon={<FaMoneyBillWaveAlt />}/>
                    <CustomButton text={'Customer Note'} icon={<FaNoteSticky />}/>
                    <CustomButton text={'Mark Order'} selected={order.is_ordered} icon={<GiShoppingCart />} onClick={handleOrder}/>
                    <CustomButton text={'Enter Code'} icon={<CiBarcode />}/>
                    <CustomButton text={'Reward'} icon={<MdOutlineStarRate />}/>
                    <CustomButton text={'Quotation/Order'} icon={<MdOutlineLink />}/>
                    </>}
                </div>
                
                <Row className='h-1/2'>
                  <Col md={{span: 11}} className='h-full'>
                    <div className='h-1/4'><CustomButton disabled={order.status==='paid' ? true : false} text={order.cus_name ? order.cus_name : 'Customer'} onClick={()=>navigate('/pos/session/sells/customers')} icon={<FaUser />}/></div>
                    {order.status !== 'paid' ? 
                      <div className='bg-[#05bcc4] h-3/4'>
                        <Button type='text' disabled={order.status==='paid' ? true : false} onClick={openPayment} className='font-semibold w-full h-full flex flex-col items-center rounded-none'>
                          <GiPayMoney size={'4rem'}/>
                          <span style={{height: '26px', color: 'white'}}>Payment</span>
                        </Button>
                      </div> :
                      <div className='bg-[#05bcc4] h-3/4'>
                        <Button type='text' onClick={gotoPrint} className='font-semibold w-full h-full flex flex-col items-center rounded-none'>
                          <MdPrint size={'4rem'}/>
                          <span style={{height: '26px', color: 'white'}}>Print Order</span>
                        </Button>
                      </div>
                    }
                  </Col>
                  <Col md={{span: 13}} className='h-full'>
                    <CalculatorButton disabled={order.status === 'paid'} carts={order.orderlines} setCarts={dispatch} tax={tax} />
                  </Col>
                </Row>
              </div>
            </div>
          </Col>
          <Col md={{span: 16}} className='right-col-container'>
            {/* {!location.pathname.split('/').slice(-1).includes('sells') && <GoBack />} */}
            <Outlet context={{success, error, order}}/>
          </Col>
        </Row>
      </div>
      <DeliveryRegionModal />
      <PaymentModal />
    </div>
  )
}

export default SellPage